import { useState } from "react";
import { createAppApi } from "../../app/api";
import { useNavigate } from "react-router-dom";

export default function CreateAppPage() {

  const navigate = useNavigate();

  const [form, setForm] = useState({
    app_name: "",
    server_ip: "",
    database_name: "",
    app_platform: "",
    content: "",
    policy_url: "",
    description: "",
    source_zip: null,
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (key, value) => {
    setForm(prev => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const payload = new FormData();
      Object.entries(form).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          payload.append(key, value);
        }
      });
      const res = await createAppApi(payload);

      if (res.success) setSuccess(true);

    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen px-6 py-6  bg-gradient-to-br from-[#140c2b] via-[#1f1147] to-[#0f0825] md:mt-20 rounded-[20px]">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">

        <div>
          <h1 className="text-3xl font-semibold text-white ">
            Create App Project
          </h1>
          <p className="text-white/60 text-sm">
            Configure your application
          </p>
        </div>

        <button
          onClick={() => navigate(-1)}
          className="px-5 py-2 bg-gray-700 text-white rounded-lg whitespace-nowrap  "
        >
          ← Back
        </button>

      </div>

      <form onSubmit={handleSubmit} className="space-y-1 grid grid-cols md:grid-cols-4 gap-3 mt-4">

     

          <Input required label="App Name"
            value={form.app_name}
            onChange={(v)=>handleChange("app_name",v)}
          />

          <Input required label="Server IP"
            value={form.server_ip}
            onChange={(v)=>handleChange("server_ip",v)}
          />

          <Input required label="Database Name"
            value={form.database_name}
            onChange={(v)=>handleChange("database_name",v)}
          />

          <Select required label="App Platform"
            value={form.app_platform}
            options={[
              { label: "Select Platform", value: "" },
              { label: "Android App", value: "android" },
              { label: "iOS App", value: "ios" },
              { label: "Android & iOS App", value: "android_ios" },
            ]}
            onChange={(v)=>handleChange("app_platform",v)}
          />

          <Input label="Policy URL"
            value={form.policy_url}
            onChange={(v)=>handleChange("policy_url",v)}
          />

          <FileInput required label="Source Code ZIP"
            fileName={form.source_zip?.name}
            onChange={(file)=>handleChange("source_zip", file)}
          />

          <Textarea required label="Content"
            value={form.content}
            onChange={(v)=>handleChange("content",v)}
          />

          <Textarea label="Description"
            value={form.description}
            onChange={(v)=>handleChange("description",v)}
          />

<button
            type="submit"
            className="px-6 py-3 whitespace-nowrap rounded-xl bg-gradient-to-r from-purple-600 to-indigo-600 text-white mt-2"
          >
            {loading ? "Creating..." : "Create App Project"}
          </button>

      </form>

          {/* </Section> */}

          {/* <div className="flex justify-end"> */}
          {/* <button
            type="submit"
            className="px-6 py-3 whitespace-nowrap rounded-xl bg-gradient-to-r from-purple-600 to-indigo-600 text-white mt-2"
          >
            {loading ? "Creating..." : "Create App Project"}
          </button> */}
        {/* </div> */}

      {success && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50">
          <div className="bg-[#1f1147] p-6 rounded-xl text-center text-white">
            <h2 className="text-xl mb-2">🎉 Project Created</h2>
            <button
              onClick={() => navigate("/apps/my")}
              className="mt-3 px-4 py-2 bg-indigo-600 rounded"
            >
              Go Back
            </button>
          </div>
        </div>
      )}

    </div>
  );
}








function Section({ title, children }) {
    return (
      <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl p-6">
        <h2 className="text-white font-semibold mb-4 text-lg">{title}</h2>
        <div className=" gap-5">{children}</div>
      </div>
    );
  }
  
  function Input({ label, value, onChange, type="text", required }) {
    return (
      <div>
        <label className="text-sm text-white/60">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
  
        <input
          type={type}
          value={value}
          onChange={(e)=>onChange(e.target.value)}
          className="w-full mt-1 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white"
        />
      </div>
    );
  }

  function Select({ label, value, onChange, options, required }) {
    return (
      <div>
        <label className="text-sm text-white/60">
          {label} {required && <span className="text-red-500">*</span>}
        </label>

        <select
          value={value}
          required={required}
          onChange={(e)=>onChange(e.target.value)}
          className="w-full mt-1 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white"
        >
          {options.map((option) => (
            <option key={option.value} value={option.value} className="bg-[#1f1147] text-white">
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  }

  function FileInput({ label, fileName, onChange, required }) {
    return (
      <div>
        <label className="text-sm text-white/60">
          {label} {required && <span className="text-red-500">*</span>}
        </label>

        <input
          type="file"
          accept=".zip"
          required={required}
          onChange={(e)=>onChange(e.target.files?.[0] || null)}
          className="w-full mt-1 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white file:mr-4 file:rounded-lg file:border-0 file:bg-indigo-600 file:px-3 file:py-2 file:text-white"
        />
        {fileName && (
          <p className="mt-1 text-xs text-white/50">{fileName}</p>
        )}
      </div>
    );
  }
  
  function Textarea({ label, value, onChange, required }) {
    return (
      <div className="col-span-2">
        <label className="text-sm text-white/60">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
  
        <textarea
          value={value}
          onChange={(e)=>onChange(e.target.value)}
          className="w-full mt-1 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white"
        />
      </div>
    );
  }
